import { Box } from "@mui/material"
import { makeStyles } from "tss-react/mui-compat"
import { ConventionCuratorHasNoFallback } from "components/common/ConventionCuratorHasNoFallback"
import { ExhibitorsPageName } from "components/exhibitors/ExhibitorsPageName"
import { useExhibitorCopyText } from "hooks/exhibitors/useExhibitorsCopyText"
import React from "react"

const useStyles = makeStyles()(
  (theme) => ({
    container: {
      position: "relative",
      width: "100%",
      height: "100%",
      marginTop: 30,
      marginBottom: 40,

      [theme.breakpoints.up(720)]: {
        marginTop: 50,
      },
    },
    headerContainer: {
      width: "100%",
    },
  })
)

interface NoExhibitorsFallbackProps {
  hasExhibitors: boolean
  children: React.ReactNode
}

export const NoExhibitorsFallback = (props: NoExhibitorsFallbackProps) => {
  const { hasExhibitors, children } = props
  const { classes } = useStyles()
  const exhibitorCopyText = useExhibitorCopyText()

  // need to wrap with <></> to satisfy TS
  if (hasExhibitors) return <>{children}</>

  return (
    <Box className={classes.container}>
      <Box className={classes.headerContainer}>
        <ExhibitorsPageName />
      </Box>
      <ConventionCuratorHasNoFallback hasNo={`${exhibitorCopyText?.plural}`} />
    </Box>
  )
}
